<template>
  <div class="h-screen">
    <div
      class="text-lg text-gray-92 text-center pb-24"
      style="padding-top: 70px"
    >
      見積もりとメッセージを送信しました。
    </div>
    <button
      class="block mx-auto bg-secondary-main text-white font-semibold rounded hover:button focus:outline-none"
      style="width: 200px; height: 40px"
      @click="toTxSummary()"
    >
      依頼概要に戻る
    </button>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  props: {
    transactionId: {
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const toTxSummary = () => {
      router.push({ name: 'TxSummary', params: { id: props.transactionId } });
    };

    return {
      toTxSummary,
    };
  },
};
</script>

<style lang="scss" scoped></style>
